//import React from 'react';
// 3) HELMET - Add this import to each page
import React, { Fragment, useRef, useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import ScrollTrigger from 'gsap/ScrollTrigger';
import { SplitText } from "gsap/SplitText";
import { DrawSVGPlugin } from '../js/DrawSVGPlugin.js'; // Import the JavaScript file
import { MotionPathPlugin} from '../js/MotionPathPlugin.js'; // Import the JavaScript file
import { Physics2DPlugin} from '../js/Physics2DPlugin.min.js'; // Import the JavaScript file
import { InertiaPlugin} from '../js/InertiaPlugin.min.js'; // Import the JavaScript file

import { NavLink } from 'react-router-dom';



import heroimg_services from '../images/heros/services.webp'; // Tell webpack this JS file uses this image



import services_img_1 from '../images/services/services-page-web-development.webp'; 


//import lightbulb_1_back from '../images/services/hero-lightbulb-1-back.webp'; 
//import lightbulb_1_front from '../images/services/hero-lightbulb-1-front.webp'; 
//import lightbulb_1_light from '../images/services/lighthouse-light-glare.webp'; 
//import lightbulb_2_back from '../images/services/hero-lightbulb-2-back.webp'; 
//import lightbulb_2_front from '../images/services/hero-lightbulb-2-front.webp'; 
//import lightbulb_3_back from '../images/services/hero-lightbulb-3-back.webp'; 
//import lightbulb_3_front from '../images/services/hero-lightbulb-3-front.webp'; 
import services_quote_icon from '../images/icons/icon-estimate.svg'; 
//import graphic_design_section_bg from '../images/services/graphic-design-twirl-bg.webp'; 
//import beach_ball from '../images/services/beach-ball.svg';



import lightbulb_1 from '../images/services/graphic-design-services-bulb-lighthouse.webp'; 
import lightbulb_1_front from '../images/services/graphic-design-services-bulb-lighthouse-light.webp'; 
import lightbulb_2 from '../images/services/graphic-design-services-bulb-hotel.webp';  
import lightbulb_3 from '../images/services/graphic-design-services-bulb-beach-ball.webp'; 
import lightbulb_3_back from '../images/services/graphic-design-services-bulb-beach.webp'; 
import graphic_design_section_bg from '../images/services/graphic-design-services-hero-bg.webp'; 




// SCROLLING ANIMATION
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(MotionPathPlugin);
gsap.registerPlugin(InertiaPlugin);
gsap.registerPlugin(Physics2DPlugin);




const Services = () => {

  const bgfx_ref_5 = useRef();



useGSAP(() => {

    //Presets
    gsap.set(".services-transition-curtain", {left:"-4000", top:"-4000"});
 


 // =============================================== //
// HERO ANIMATION
// =============================================== //
// presets
gsap.set("#arrow-wheel-1", {y: "40px"});
gsap.set("#arrow-wheel-2", {y: "-50px", x:"30px"});
gsap.set("#arrow-wheel-3", {y: "-30px", x:"-30px"});


// HERO  - ARROW CIRCLE FX
let tlarrowfx = gsap.timeline({repeat:-1, delay:5});

tlarrowfx
.to("#arrow-wheel-1", {duration:10, rotateZ: 360,  transformOrigin:"center center", ease: "none"})
.to("#arrow-wheel-2", {duration:10, rotateZ: 360,  transformOrigin:"center center", ease: "none", delay:-10})
.to("#arrow-wheel-3", {duration:10, rotateZ: -360,  transformOrigin:"center center", ease: "none", delay:-10})

// HERO - DIGITAL TYPE EFFECT
// ================================ //
 let text1;
 let text2;
 let text3;

 let typingText1 = document.getElementById("typing-text-1");
 let typingText2 = document.getElementById("typing-text-2");
 let typingText3 = document.getElementById("typing-text-3");	
	
 let index1 = 0;
 let index2 = 0;
 let index3 = 0;	
	
function typefx_1() {
  text1 = "function shuffleRandomChars(){	currentIntervalId = setInterval(() => {gfx.querySelector(gobject).innerHTML =getRandomElement(randChars);}, glitchSpeed);}";
  if (index1 < text1.length) {
    typingText1.textContent += text1.charAt(index1);
    index1++;
    setTimeout(typefx_1, 10);
  }
}
function typefx_2() {
  text2 = "A chaotic collision of pure type and liquid layout. It is a seamless collaboration where design meets code in its most unpredictable form. Random logic dictates the interface, turning raw text strings into kinetic visual anchors.";
  if (index2 < text2.length) {
    typingText2.textContent += text2.charAt(index2);
    index2++;
    setTimeout(typefx_2, 10); 
  }
}
function typefx_3() {
  text3 = "Supercharge your workflow with simulated AI enhancements and aggressive template override systems. This framework bypasses standard limitations to inject dynamic, intelligent modifications directly into your core layout";
  if (index3 < text3.length) {
    typingText3.textContent += text3.charAt(index3);
    index3++;
    setTimeout(typefx_3, 10); 
  }
}	
	
let tl_typerfx  = gsap.timeline({});

function resetTypeFX(){
  typingText1.textContent = "";
  typingText2.textContent = "";
  typingText3.textContent = "";
  startTypeFX();
}
function startTypeFX(){
  gsap.set("#cursorfx-1", {autoAlpha:1});
  gsap.set("#cursorfx-2", {autoAlpha:1});
  gsap.set("#cursorfx-3", {autoAlpha:1});
  index1 = 0;
  index2 = 0;
  index3 = 0;
  typefx_1();
  typefx_2();
  typefx_3();
  tl_typerfx.to("#cursorfx-3", {duration:5, onComplete:resetTypeFX});	
}
tl_typerfx.to("#cursorfx-3", {duration:1, onComplete:startTypeFX, delay:3.5});

// EOF HERO ANIMATIONS >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 

// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
// HERO PLAY CONTROLLER 
//  When scrolled past 800 pixels pasies, resumes when scollred back
// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
window.addEventListener('scroll', function() {

    if (window.scrollY > 300) {
      tlarrowfx.pause();        
      tl_typerfx.pause();    
    } else {
       tlarrowfx.play();        
      tl_typerfx.play();    
    }
       
});








  //Scroll Animation Trigger
    // ============================================= //
    //Presets
    gsap.set(".services-wd-image-wrap, .wd-ul-1 li, .wd-ul-2 li", {opacity:0});
    gsap.set(".wd-ul-1 li span, .gd-ul-1 li span", {x: "80px", opacity:0});
    gsap.set(".wd-ul-2 li span, .gd-ul-2 li span", {x: "80px", opacity:0});
    gsap.set(".wd-content h2", {x: "20px", opacity:0});
    gsap.set(".wd-content p", {y: "30px", opacity:0});

    // DYNAMIC DELAY VALUE
    const dynamicDelay = window.isInitialPreload ? 5 : 2;

// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx //
//WEB DEVELOPMENT -  Content Animation
// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx //

  let tl_wd_content  = gsap.timeline({
// Dynamic Dealy Value
  onComplete: () => {window.isInitialPreload = false;}
  });
     
 /* inital content on top of page to be shown */
  tl_wd_content
  .to(".wd-content h2", {duration:1, opacity: 1, x:"0px"}, `+=${dynamicDelay}`)
  .to(".wd-content p", {duration:1, opacity: 1, y:"0px"})
  .to(".services-wd-image-wrap", { opacity: 1, duration:1, delay:-1});

/* flag */
let listwd = false;
let wd_butn = document.querySelector(".button_services_list");
let wd_butn_label = document.querySelector(".button_label_wd");
let wd_arrow = document.querySelector(".button_services_arrow");

let tl_wd_content_list = gsap.timeline({
  scrollTrigger: {
    trigger: ".wd-content-2", 
    start: "top 80%",        
    toggleActions: "play none none none" 
  }
});

// Web Development Bullets
  tl_wd_content_list
  .to(".wd-ul-1 li", { opacity: 1, duration: 0.5, ease: "power2.out", stagger:0.15})
  .to(".wd-ul-1 li span", { opacity:1, x: "0px", duration: 0.5, ease: "power2.out", stagger:0.15, delay:"-1.25"})
  .to(".wd-ul-2 li", { opacity: 1, duration: 0.5, ease: "power2.out", stagger:0.15, delay:-0.5})
  .to(".wd-ul-2 li span", {opacity:1, x: "0px", duration: 0.5, ease: "power2.out", stagger:0.15, delay:"-1.25"});
   //.to(".services-wd-image-wrap", {duration:5, ease: "power2.out", backgroundPosition:360, delay:-4});

const target = document.querySelector(".services-wd-image-wrap");

window.addEventListener("mousemove", (e) => {
  // Calculate mouse position as a ratio between 0 and 1
  const mouseXRatio = e.clientX / window.innerWidth;
  const targetX = mouseXRatio * 100; 

  gsap.to(target, {
    duration: 1,           
    ease: "power2.out",
    backgroundPosition: `${targetX}% center`, 
    overwrite: "auto"      // Prevents animation glitches if the mouse moves fast
  });
});










// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx //
// GRAPHIC DESIGN -  Content Animation
// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx //

let gd_butn_label = document.querySelector(".button_label_gd");

gsap.set(" .img-4, .img-2, .img-3, .img-1, .hotel-spotlights", {scale:0.5, opacity:0});
gsap.set(".graphic-design-services-bg, .gd-h2, .gd-p1", {y:"40px", opacity:0});
gsap.set(".gd-ul-1 li, .gd-ul-2 li, .gd-ul-3 li", {opacity:0});

 // 1. Define the ScrollTrigger directly on the timeline configuration
let tl_gd_content = gsap.timeline({
  scrollTrigger: {
    trigger: ".gd-content-1",
    start: "top 80%", // Starts when the top of .gd-content-1 hits 80% of the viewport height
    toggleActions: "play none none none" // Plays once when entering
  }
});



tl_gd_content
  .to(".gd-h2", { opacity: 1, y: "0px", duration: 0.75})
  .to(".gd-p1", { opacity: 1, y: "0px", duration: 0.75, delay:-0.5})
  .to(".graphic-design-services-bg", { opacity: 1, y: "0px", duration: 0.75, ease: "power1.out", stagger: 0.25, delay:-0.25 })
  .to(".img-2, .img-1", { opacity: 1, scale: 1, duration: 1, ease: "elastic.out(1,0.3)", stagger: 0.25, delay:-0.75})
  .to(".img-4", { opacity: 1, scale: 1, duration: 1, ease: "elastic.out(1,0.3)", stagger: 0.25, delay:-0.75 })
  .to(".img-3", { opacity: 1, scale: 1, duration: 1, ease: "elastic.out(1,0.3)", stagger: 0.25, delay:-0.75 })
   .to(".hotel-spotlights", { opacity: 1, duration: 0.5, stagger: 0.25, delay:-0.75 })
  .to(".graphic-design-services h2", { opacity: 1, x: "0px", duration: 1 });


let tl_gd_content_list = gsap.timeline({
  scrollTrigger: {
    trigger: ".gd-content-2", 
    start: "top 80%",         
    toggleActions: "play none none none" 
  }
});
  tl_gd_content_list.to(".gd-ul-1 li", { opacity: 1, duration: 0.5, ease: "power2.out", stagger:0.15})
  .to(".gd-ul-1 li span", { opacity:1, x: "0px", duration: 0.5, ease: "power2.out", stagger:0.15, delay:"-1.25"})
  .to(".gd-ul-2 li", { opacity: 1, duration: 0.5, ease: "power2.out", stagger:0.15, delay:-0.5})
  .to(".gd-ul-2 li span", {opacity:1, x: "0px", duration: 0.5, ease: "power2.out", stagger:0.15, delay:"-1.25"});




// TITLE ANIMATION TEXT FX
// --------------------------------------- //
// BLUR PLUGIN +++++
// https://codepen.io/GreenSock/pen/NWKjEBG?editors=0010
	const blurProperty = gsap.utils.checkPrefix("filter"),
		    blurExp = /blur\((.+)?px\)/,
		    getBlurMatch = target => (gsap.getProperty(target, blurProperty) || "").match(blurExp) || [];

	gsap.registerPlugin({
		name: "blur",
		get(target) {
			return +(getBlurMatch(target)[1]) || 0;
		},
		init(target, endValue) {
			let data = this,
          filter = gsap.getProperty(target, blurProperty),
          endBlur = "blur(" + endValue + "px)",
          match = getBlurMatch(target)[0],
          index;
      if (filter === "none") {
        filter = "";
      }
      if (match) {
        index = filter.indexOf(match);
        endValue = filter.substr(0, index) + endBlur + filter.substr(index + match.length);
      } else {
        endValue = filter + endBlur;
        filter += filter ? " blur(0px)" : "blur(0px)";
      }
      data.target = target; 
      data.interp = gsap.utils.interpolate(filter, endValue); 
		},
		render(progress, data) {
			data.target.style[blurProperty] = data.interp(progress);
		}
	});











// ----------------------------------------- //
// Interactive Light Bulbs code
// --------------------------------------- //
  
// LIGHTHOUSE >>>>>>>>>>>>>>>>>>>

const butn1 = document.querySelector('#butn-1');
const lightbulb1 = document.querySelector('.img-4');
const light = document.querySelector('.img-5');

// Set initial states
gsap.set(light, { opacity: 0 });

// 1. Reusable pulse tween
const pulseAnimation = gsap.to(light, {
  opacity: 0.2,
  duration: 0.6,
  repeat: -1,
  yoyo: true,
  ease: "power1.inOut",
  paused: true
});

// 2. Main enter/leave timeline
const hoverTl = gsap.timeline({ paused: true })
  .to([lightbulb1, light], {
    scale: 1.2,
    duration: 0.5,
    ease: "power2.out"
  }, 0)
  .to([lightbulb1, light], {
    opacity: 1,
    duration: 0.2,
    ease: "power2.out",
    onComplete: () => {
      // Start pulsing only if hovered
      if (butn1.matches(':hover')) {
        pulseAnimation.restart();
      }
    }
  }, 0);

// Mouse Enter: Play hover timeline forward
butn1.addEventListener('mouseenter', () => {
  hoverTl.play();
});

// Mouse Leave: Kill pulse & reverse the main timeline smoothly
butn1.addEventListener('mouseleave', () => {
  // Gracefully stop the pulse loop
  pulseAnimation.pause();

  // Smoothly blend opacity back to where hoverTl expects it, then reverse
  gsap.to(light, {
    opacity: 1,
    duration: 0.15,
    onComplete: () => hoverTl.reverse()
  });
});



// BEACH >>>>>>>>>>>>>>>>>>>

const butn3 = document.getElementById('butn-3');
const card = document.querySelector('.lightbulb-beach');
const ball = document.querySelector('.ball');

let isHovered = false;
let bounceAnimation = null;

function playBounce() {
  bounceAnimation = gsap.timeline({
    onComplete: () => {
      // If the cursor is still hovering when the bounce finishes, loop it again
      if (isHovered) {
        playBounce();
      }
    }
  });

  bounceAnimation
    .to(ball, {
      y: -120,
      duration: 0.35,
      ease: "power2.out",
    })
    .to(ball, {
      y: 0,
      duration: 0.75,
      ease: "bounce.out" // Real physics drop-and-bounce effect
    });
}

function scaleBulb3_on(){
  gsap.to([card, ball], {
      scale: 1.4,
      duration: 1,
      ease: "power2.out",
       transformOrigin: "right center"
    })
}
function scaleBulb3_off(){
  gsap.to([card, ball], {
      scale: 1,
      duration: 1,
      ease: "power2.out"
    })
}

butn3.addEventListener('mouseenter', () => {
  isHovered = true;
  
 
  // If not currently bouncing, kick off the loop
  if (!bounceAnimation || !bounceAnimation.isActive()) {
    scaleBulb3_on();
    playBounce();
  }
});

butn3.addEventListener('mouseleave', () => {
  isHovered = false;
  scaleBulb3_off();
});


// CITY >>>>>>>>>>>>>>>>>>>

const butn2 = document.getElementById('butn-2');
const container_bulb_3 = document.querySelector('.img-3');
const spotlights = document.querySelector('.hotel-spotlights');


// 1. Set transform origin for pivot points
gsap.set('.spotlight_1, .spotlight_2', { transformOrigin: 'center bottom' });

// 2. Animate both lights simultaneously in a single timeline
const spotlightTween = gsap.timeline({ paused: true, repeat: -1, yoyo: true })
  .to('.spotlight_1', { rotate: 15, duration: 2.5, ease: 'sine.inOut' }, 0)
  .to('.spotlight_2', { rotate: -15, duration: 2.5, ease: 'sine.inOut' }, 0)
  .to('.spotlight_1', { rotate: -15, duration: 2.5, ease: 'sine.inOut' }, '> ')
  .to('.spotlight_2', { rotate: 15, duration: 2.5, ease: 'sine.inOut' }, '<');

// Bulb scale handlers
function ScaleBulb2_up() {
  gsap.to([container_bulb_3, spotlights], { duration: 0.5, scale: 1.4 });
}

function ScaleBulb2_down() {
  gsap.to([container_bulb_3, spotlights], { duration: 0.5, scale: 1 });
}

// Hover listeners
butn2.addEventListener('mouseenter', () => {
  spotlightTween.play();
  ScaleBulb2_up();
});

butn2.addEventListener('mouseleave', () => {
  ScaleBulb2_down();
  
  // Pause the infinite loop and smoothly reset lights to vertical (0deg)
  spotlightTween.pause();
  gsap.to('.spotlight_1, .spotlight_2', {
    rotate: 0,
    duration: 1,
    ease: 'power2.out'
  });
});










// >>>>>>>> END INTERACTIVE LIGHTBULBS















// xxxxxxxxxxxxxxxxxxxxxxxxxxx
// QUOTE SECTION
// xxxxxxxxxxxxxxxxxxxxxxxxxxx

// title Animation H3
const quotes = document.querySelectorAll(".services-details h3");
// presets
  quotes.forEach((quote) => {
    // Reset if needed
    if (quote.anim) {
      quote.anim.progress(1).kill();
      quote.split.revert();
    }

    quote.split = new SplitText(quote, {
      type: "lines,words,chars",
      linesClass: "split-line"
    });

    gsap.set(quote.split.chars, {opacity:1});

    // Set up the anim
    quote.anim = gsap.from(quote.split.chars, {
      scrollTrigger: {
        trigger: quote,
       // toggleActions: "restart pause resume reverse",
        start: "center center",
        end: "bottom+=1000px",
        markers: { startColor: "#dfdcff", endColor: "transparent" }
      },
      duration: 0.3,
      ease: "circ.out",
      opacity:0,
      blur: 4,
      stagger: 0.02
    });
  });



  // Calculator Outline Animation - for quote section at footer
// presets stroke to zero
gsap.set(".calc-outlines", {strokeWidth: 0});
gsap.set(".hourly-rate, .quote-link", {autoAlpha: 0});
gsap.set(".service-crd-1 h4", {autoAlpha: 0, y:"-20px"});
gsap.set(".service-crd-1 span", {autoAlpha: 0, x:"40px"});
gsap.set(".services-get-a-quote h2, .service-crd-2 p", {autoAlpha: 0, y:"20px"});
gsap.set(".service-crd-2 h4", {autoAlpha: 0, y:"-20px"});





let tl_qoute = gsap.timeline({
    scrollTrigger: {
      trigger: ".services-get-a-quote",
      start: "top center",
      //scrub: true,
     // end: "bottom+=2000px",
      markers: false
    }
  })
 .to(".services-get-a-quote h2", {duration: 1, y:"0px", autoAlpha:1, onStart:calculatorAnmt})
 .to(".service-crd-1 h4", {duration: 1, y:"0px", autoAlpha:1, delay:-0.75})
 .to(".service-crd-2 h4", {duration: 1, y:"0px", autoAlpha:1, delay:-1})
 .to(".service-crd-2 p", {duration: 1, y:"0px", autoAlpha:1, delay:-1.25})
 .to(".service-crd-1 span", {duration: 1.5, x:"0px", autoAlpha:1,  delay:-1.25})
 .to(".quote-link", {duration: 1.5, autoAlpha:1,  delay:-1});  // This is the moving h1 text behind monitor

 

 let tl_calc_lines = gsap.timeline({});

function calculatorAnmt(){
 tl_calc_lines
 .set(".calc-outlines", { opacity: 1, drawSVG: "0%", strokeWidth: 1, fill: "none", scale: 1, rotate: 0 })
 .to(".calc-outlines", { duration: 8, strokeWidth: 1, drawSVG: "100%",  autoAlpha:1 })
 .to(".hourly-rate", {autoAlpha:1, duration: 3, ease: "power4.out", delay:-8, onStart:herotxtfx});

 // SpliText FX
     let splitTitleQuote = new SplitText(".hourly-rate", {
      type: "words,chars"
    });

    let chars = splitTitleQuote.chars; //an array of all the divs that wrap each character

    function herotxtfx() {
      gsap.from(chars, {
        duration: 0.2,
        opacity: 0,
        y: 10,
        ease: "none",
        delay:1,
        stagger: {
          each: 0.05,
          from: "random"
        }
      });
    }  
}




}, { scope: bgfx_ref_5 }); 
   // End of useGSAP











   



  return (
  
<main className="page-content page-id_services" data-page-id="services" ref={bgfx_ref_5}>
<HelmetProvider> 
<Fragment> 
      <Helmet>
        <title>Graphic Design and Web Development Services | MHD</title>
        <meta name="description" content="Professional graphic designs and web development services by Mark Hawkins. Over 20 years experience. Hire me for your next project."/>
      
      </Helmet>
</Fragment>
</HelmetProvider> 

<svg version="1.1" className="services-transition-curtain transition-curtain" x="0px" y="0px"viewBox="0 0 191 191" xmlSpace="preserve">
<path className="st0" d="M95.5,190.5c-52.4,0-95-42.6-95-95s42.6-95,95-95s95,42.6,95,95S147.9,190.5,95.5,190.5z"/>
<path className="st1" d="M95.5,1C147.6,1,190,43.4,190,95.5S147.6,190,95.5,190S1,147.6,1,95.5S43.4,1,95.5,1 M95.5,0
	C42.8,0,0,42.8,0,95.5S42.8,191,95.5,191S191,148.2,191,95.5S148.2,0,95.5,0L95.5,0z"/>
</svg>








<div className="hero-container-wrap">   
<div className='hero-container'>
  <div className="hero-mask">

  <div className='mask-svg'>
    <svg viewBox="0 0 0 0" height="0" width="0">
      <defs> 
          <clipPath id="clipping" clipPathUnits="objectBoundingBox" transform="scale(0.00099, 0.00105)"> 
              <path id="dotmask" d="M853,0c0,357.9-290.1,648-648,648c-71.6,0-140.6-11.6-205-33.1v158.6C65.4,790.8,134.1,800,205,800
			c441.8,0,800-358.2,800-800H853z"/>
              <path id="hoopmask"  d="M0,0v501.1c63.2,25.9,132.4,40.2,205,40.2c298.9,0,541.3-242.3,541.3-541.3H0z"/>
	        </clipPath>
      </defs> 
    </svg>
  </div>
 



  { /* hero image SVG  */ } 
 <div className='heroimage'>



 <div className="cursorfx-wrapper">	
  <div className="cursorfx">
	<div id="cursorfx-1">	
 		 <span id="typing-text-1"> </span><span className="cursor">&#9616;</span>
	</div>
	<div id="cursorfx-2">	
  		<span id="typing-text-2"> </span><span className="cursor">&#9616;</span>
	</div>
	<div id="cursorfx-3">	
 		 <span id="typing-text-3"> </span><span className="cursor">&#9616;</span>
	</div>
  </div>	
</div>

<div className="arrow-wheel-wrap">
<svg version="1.1" viewBox="0 0 2400 1732" className="arrow-wheel-fx">
  <g id="arrow-wheel-1">
      <path className="arrow-wheel" d="M1971.1,769.7c-.2,181.6-148,329.3-329.6,329.3s-329.6-147.9-329.6-329.6,139.5-321.1,314.1-329.3v21l48.2-24.1-48.2-24.1v21c-39.9,1.8-78.5,10.5-115.2,26-40,16.9-75.9,41.1-106.7,72-30.8,30.8-55.1,66.8-72,106.7-17.5,41.4-26.4,85.4-26.4,130.7s8.9,89.3,26.4,130.7c16.9,40,41.1,75.9,72,106.7,30.8,30.8,66.8,55.1,106.7,72,41.4,17.5,85.4,26.4,130.7,26.4s89.3-8.9,130.7-26.4c40-16.9,75.9-41.1,106.7-72,30.8-30.8,55.1-66.8,72-106.7,17.5-41.3,26.3-85.1,26.4-130.3h-6.2Z"/>
      <rect className="arrow-wheel-spacer" x="1620.2" y="1104.2" width="5.8" height="21"/>
    </g>
  <g id="arrow-wheel-2">
      <path className="arrow-wheel" d="M776.9,866.6c-.2,153.5-125.1,278.4-278.7,278.4s-278.7-125-278.7-278.7,118-271.5,265.6-278.4v17.8l40.8-20.4-40.8-20.4v17.8c-33.7,1.5-66.4,8.9-97.4,22-33.8,14.3-64.2,34.8-90.2,60.8-26.1,26.1-46.5,56.4-60.8,90.3-14.8,35-22.3,72.2-22.3,110.5s7.5,75.5,22.3,110.5c14.3,33.8,34.8,64.2,60.8,90.3,26.1,26.1,56.4,46.5,90.2,60.8,35,14.8,72.2,22.3,110.5,22.3s75.5-7.5,110.5-22.3c33.8-14.3,64.2-34.8,90.2-60.8,26.1-26.1,46.5-56.4,60.8-90.3,14.8-34.9,22.3-72,22.3-110.2h-5.2Z"/>
      <rect className="arrow-wheel-spacer" x="480.2" y="1149.4" width="4.9" height="17.8"/>
    </g>
    <g id="arrow-wheel-3">
      <path className="arrow-wheel" d="M874.9,262.6h-3.9c0,28.5,5.7,56.2,16.7,82.3,10.7,25.2,26,47.9,45.5,67.4,19.5,19.5,42.1,34.8,67.4,45.5,26.2,11.1,53.9,16.7,82.6,16.7s56.4-5.6,82.6-16.7c25.2-10.7,47.9-26,67.4-45.5,19.5-19.5,34.8-42.1,45.5-67.4,11.1-26.2,16.7-53.9,16.7-82.6s-5.6-56.4-16.7-82.6c-10.7-25.2-26-47.9-45.5-67.4-19.5-19.5-42.1-34.8-67.4-45.5-23.2-9.7-47.6-15.3-72.8-16.4v-13.3s-30.5,15.2-30.5,15.2l30.5,15.2v-13.3c110.3,5.1,198.4,93.2,198.4,208,0,114.8-93.5,208.2-208.2,208.2s-208.1-93.3-208.2-208v.2Z"/>
      <rect className="arrow-wheel-spacer" x="1069.7" y="473.7" width="3.7" height="13.3"/>
    </g>
</svg>
</div>

    { /* hero image  */ } 
      <img src={heroimg_services} alt="Services background hero - picture of gears in a clock closeup"  />
    </div> 
  </div>

  <div className='hero-text'>
    <div className="page-h1">
     <h1 style={{ opacity: 0, visibility: 'hidden' }}>Services</h1>
     <div className="h1-accent"><span></span></div>
    </div>
    <strong>Graphic Design &amp; Web Development</strong>
  </div>

</div>
</div>  












<div className="content">

<section className="web-development-services"> 
  <div className="columns">
      <div className="col-50">
        <div className="wd-content">
          <h2>Web Development</h2>


      <div className="wd-content-1">
          <p className="wd-p1">Specializing in end-to-end design and development for robust corporate and e-commerce platforms, leveraging the power of WordPress, WooCommerce, and Shopify. My process is built on two decades of experience, fusing critical elements—SEO, Usability, Marketing insight, and innovative Design—to produce websites that guarantee maximum brand impact, increased market exposure, and effortless maintenance.</p>
     </div>  
     <div className="wd-content-2">


 <div className="services-details">
   

    <div className="ul-columns">
      <div className="col-50">
          <ul className="wd-ul-1">
            <li>
              <span data-toggle="tooltip" role="tooltip">Custom Theme Design</span>
            </li>
            <li>
              <span>ADA Compliance Design</span>
            </li>
            <li>
              <span>4<sup>+</sup> Web Page Site</span>
            </li>
            <li>
              <span>up to 7 Design Revisions</span>
              </li>
            <li>
              <span>Home Page & Layout Proofs</span>
              </li>
                    <li>
            <span>1-2 Hour Consultation</span>
             </li>
          <li>
            <span>Mobile Optimization</span>
          </li>
          <li>
            <span>Keyword Discovery</span>
          </li>
          </ul>
      </div>

     <div className="col-50">
        <ul className="wd-ul-2">
          <li>
            <span>Custom Home Page Hero</span>
            </li>
          <li>
            <span>5<sup>+</sup> iStock Images</span>
            </li>
          <li>
            <span>Email Contact Form</span>
          </li>
          <li>
        <span>Creation of 2<sup>+</sup> Email Accounts</span>
       </li> 
          <li>
            <span>Site Blog</span>
            </li>
             
          <li>
            <span>Search Engine Optimzation</span>
           </li>
          <li>
            <span>W3 Certified Testing</span>
           </li>
      </ul>
     </div>

  
    </div>
</div>
 
    </div> 
 </div>

 

  </div>
    <div className="col-50"> 


<div className="services-wd-image-wrap">
      <img className="wd-img" src={services_img_1} alt="Graphic Design Services" /> 
</div>


      </div>
  </div>

 

</section>






<hr className="services-hr" />




<section className="graphic-design-services"> 
<div className="columns">

  <div className="col-50">
	  <div className="graphic-design-services-hero">



<svg className="rect-buttons" viewBox="0 0 2168 1463">
  <g id="bulb-butns">
    <path id="butn-3" className="st0x" d="M2007.3,418.5c76,56.5,163.9,184.8,119.7,313-59.6,172.9-209.4,206-238.5,237.8s-59.6,140.5-90.1,161.7-54.3,51.7-71.6,82.2-38.4,103.4-58.3,111.3-76.9,22.5-100.7,21.2-96.3-70.7-99.4-119.7,70.2-163.9,79.5-190.4-19.4,8.4-4-63.6c18.7-87,48.7-205.3,53-299.5,5.7-126.8,25.2-185.1,108.7-241.2,92.2-61.9,225.7-69.3,301.7-12.8Z"/>
    <path id="butn-2" className="st0x" d="M984.7,471s-156.8-230.1,23.9-397.5,204.1-63.6,273-37.1,176.9,94.5,156.4,238.5c-31.4,219.5-100.5,188.8-121.9,257.1-22.7,72.5-9.9,152.3-33.1,183.3-56.5,75.4-28.3,196.1-51.7,211.6-14.9,9.8-64.9,50.4-76.9,53s-96.7,4-103.4-18.6-34.5-39-34.5-91.7,23.9-106.9,10.6-138.1-27.8-12.7-23.9-90.8-18.6-169.6-18.6-169.6Z"/>
    <path id="butn-1" className="st0x" d="M210.8,198.1c71.6-31.8,315.1-89.5,432,103.4,151.1,249.1,13.3,336.6,26.5,430.1,30.4,214.2,43.7,285.5,34.5,301.4s55.7,212,50.4,235.9-24,109.6-66.3,127.2c-125.9,52.6-134.7-5.7-217.3-50.3-16.8-9-39.8-212.1-63.6-222.7s-42.4-4-71.6-61-41-182.5-172.3-291.5C22.7,653.9-79.4,362.4,210.8,198.1Z"/>
  </g>
</svg>
      <img className="img-5" src={lightbulb_1_front} alt="" />
      <img className="img-4" src={lightbulb_1} alt="" />



<svg className="hotel-spotlights" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2168 1581.3">
  <defs>
    <linearGradient id="linear-gradient" x1="509" y1="1049.8" x2="414.5" y2="435.8" gradientTransform="translate(35.2 -64.4) rotate(3.6)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#fff" stop-opacity=".3"/>
      <stop offset="1" stopColor="#fff" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="linear-gradient2" x1="1151.3" y1="422.2" x2="1104.2" y2="116.3" gradientTransform="translate(94.6 -187.4) rotate(9.9)" xlinkHref="#linear-gradient"/>
    <linearGradient id="linear-gradient3" x1="586.3" y1="423.5" x2="539.2" y2="117.6" gradientTransform="translate(1870.5952 121.7323) rotate(-170.1255) scale(1 -1)" xlinkHref="#linear-gradient"/>
  </defs>
  <g id="spotlights">
    <polygon id="spotlight_2" class="st0z spotlight_2" points="1140 707.2 1143.9 120.1 1181 121.5 1140 707.2"/>
    <polygon id="spotlight_1" class="st3z spotlight_1" points="1141.2 707.5 1335.9 153.5 1300.6 142.3 1141.2 707.5"/>
  </g>
</svg>


      <img className="img-3" src={lightbulb_2} alt="" />

      <img className="img-2 lightbulb-beach" src={lightbulb_3_back} alt="" />
      <img className="img-1 ball" src={lightbulb_3} alt="" />

      <img className="graphic-design-services-bg" src={graphic_design_section_bg} alt="" /> 
	  </div>





  </div>
  <div className="col-50">
  <div className="gd-content">
    <h2 className="gd-h2">Graphic Design</h2>
<div className="gd-content-1">
    <p className="gd-p1">Infusing creative marketing and branding designs that powerfully communicate your unique qualities and differences about your business, services or products. Whether you need compelling hand-drawn illustrations and icons, stunning packaging design, or detailed product label designs, I have the proven expertise to cover all your graphic design needs.</p>
   </div>
   
<div className="gd-content-2">
<div className="services-details">
    <div className="ul-columns">
      <div className="col-50">
          <ul className="gd-ul-1">
            <li>
              <span>Logos</span>
            </li>
            <li>
              <span>Icons</span>
            </li>
             <li>
              <span>Illustrations</span>
            </li>
             <li>
              <span>User Interface</span>
            </li>
            <li>
              <span>Style Guides</span>
            </li>
                 <li>
            <span>Product Labels</span>
          </li>
          <li>
            <span>Product Manuals</span>
          </li>
          </ul>
      </div>

     <div className="col-50">
        <ul className="gd-ul-2">
          <li>
            <span>Business Cards</span>
            </li>
          <li>
            <span>Flyers</span>
            </li>
          <li>
            <span>Brochures</span>
            </li> 
             <li>
              <span>Posters</span>
            </li> 
            <li>
              <span>Infographics</span>
            </li>  
             
                  <li>
            <span>Banners</span>
          </li>
             <li>
              <span>Stickers</span>
            </li> 
      </ul>
     </div>
</div>
 

    </div>
</div>

   
   
    </div>
     </div>
</div>




</section>





<section className="services-details services-get-a-quote">
  <h2>Request a Quote</h2>
  <div className="rate-and-quote-grid">
    <div className="col-1">
      <div className="border-container service-crd-1">
      <h4>Hourly Rate</h4>
      <strong className="hourly-rate">$100</strong>
      <span>*quotes are based on hourly rate</span>
       </div>
    </div> 

     <div className="col-2">
          <svg version="1.1" viewBox="0 0 84 99.3" className="quote-icon">
                 <path className="calc-outlines" d="M74.1,1.1H9.9C4.9,1.1.9,5.1.9,10.1v79.1c0,5,4,9,9,9h64.2c5,0,9-4,9-9V10.1c0-5-4-9-9-9ZM20.7,88.7c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM20.7,73c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM20.7,57.3c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM37.3,88.7c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM37.3,73c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM37.3,57.3c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM53.9,88.7c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM53.9,73c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM53.9,57.3c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM74.6,88.7c0,1.1-.9,2-2,2h-8.8c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h8.8c1.1,0,2,.9,2,2v6.7ZM74.6,72.4c0,1.4-1.2,2.5-2.5,2.5h-7.8c-1.4,0-2.5-1.2-2.5-2.5v-21.2c0-1.4,1.2-2.5,2.5-2.5h7.8c1.4,0,2.5,1.2,2.5,2.5v21.2ZM74.9,35.8c0,3.6-2.9,6.6-6.6,6.6H15.6c-3.6,0-6.6-2.9-6.6-6.6v-19.5c0-3.6,2.9-6.6,6.6-6.6h52.7c3.6,0,6.6,2.9,6.6,6.6v19.5Z"/>
                 </svg>
     </div>

     <div className="col-3">
     <div className="border-container service-crd-2">
      <h4>Let's Discuss Your Project</h4>
      <p>Receive an accurate, transparent proposal within 48 hours.</p>
       <button className="colorborderfx quote-link">
        <NavLink  to="/contact"> <span className="button_label_wd">Contact Me</span> <span className="button_services_arrow"></span></NavLink>
       </button>



        </div>
    </div>
  </div>


</section>





</div>
</main>
  );
};

export default Services;